import { createSlice, createSelector } from '@reduxjs/toolkit';

// hostname별 distributor 정보 캐시 (새로고침 시 테마 깜빡임 방지)
const DIST_CACHE_KEY = `dist_info_${window.location.hostname}`;
let cachedDist = {};
try {
  const raw = localStorage.getItem(DIST_CACHE_KEY);
  if (raw) cachedDist = JSON.parse(raw);
} catch {}

const initialState = {
  me: null,
  menuItems: [],
  loading: true,
  userType: null,
  distributorId: cachedDist.distributorId || 1,
  distributorTheme: cachedDist.distributorTheme || 'dark',
  distributorName: cachedDist.distributorName || 'p!nk',
  distributorLogo: cachedDist.distributorLogo || null,
  distributorBusinessNumber: cachedDist.distributorBusinessNumber || null,
  distributorRepresentative: cachedDist.distributorRepresentative || null,
  distributorAddress: cachedDist.distributorAddress || null,
};

const reducers = {
  changeMe: (state, action) => {
    state.me = action.payload;
    state.userType = action.payload?.userType || null;
    state.distributorId = action.payload?.distributorId || 1;
    state.distributorTheme = action.payload?.distributorTheme || 'dark';
    state.distributorName = action.payload?.distributorName || 'p!nk';
    state.distributorLogo = action.payload?.distributorLogo || null;
    state.distributorBusinessNumber = action.payload?.distributorBusinessNumber || null;
    state.distributorRepresentative = action.payload?.distributorRepresentative || null;
    state.distributorAddress = action.payload?.distributorAddress || null;
  },
  setLoading: (state, action) => {
    state.loading = action.payload;
  },
  changeMenuItems: (state, action) => {
    state.menuItems = action.payload;
  },
  logout: (state) => {
    state.me = null;
    state.menuItems = [];
    state.loading = false;
    state.userType = null;
    state.distributorId = 1;
    state.distributorTheme = 'dark';
    state.distributorName = 'p!nk';
    state.distributorLogo = null;
    state.distributorBusinessNumber = null;
    state.distributorRepresentative = null;
    state.distributorAddress = null;
  },
};

const name = 'auth';

export const authSlice = createSlice({
  name,
  initialState,
  reducers,
});

export const auth = authSlice.name;
export const authReducer = authSlice.reducer;
export const authAction = authSlice.actions;

const selectAuth = (state) => state.auth;

export const authSelector = {
  selectAuthState: createSelector(selectAuth, (auth) => ({
    me: auth.me,
    menuItems: auth.menuItems,
    loading: auth.loading,
    userType: auth.userType,
    distributorId: auth.distributorId,
    distributorTheme: auth.distributorTheme,
    distributorName: auth.distributorName,
    distributorLogo: auth.distributorLogo,
    distributorBusinessNumber: auth.distributorBusinessNumber,
    distributorRepresentative: auth.distributorRepresentative,
    distributorAddress: auth.distributorAddress,
  })),
};
